import * as React from 'react';
import { setCookie } from '@cian/utils/lib/browser/cookie';

const COOKIE_KEY = 'seen_cpd_landing';

export const useSetSeenLandingInCookie = () => {
  const currentDate = new Date();
  const dateThroughOneYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

  React.useEffect(() => {
    setCookie(COOKIE_KEY, `1`, {
      expires: dateThroughOneYear,
      secure: false,
    });
  }, []);
};
